// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2n1Eq","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__34YHG"};